export default {
  state: {
    productsPerPage: 40
  }
};